import { useOnboardingRequirementsMachine } from '../components/machine-provider';

export default useOnboardingRequirementsMachine;
